var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"app-logo",attrs:{"to":{ name: 'game' }}},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.appName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }